import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';

const initialFilters = {
  startDate: '',
  endDate: '',
  difficulty: '',
  status: '',
};

const FiltersBar = ({ onApply, onReset }) => {
  const [filters, setFilters] = useState(initialFilters);

  const handleChange = (field) => (event) => {
    setFilters((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleApply = () => {
    if (onApply) onApply(filters);
  };

  const handleReset = () => {
    setFilters(initialFilters);
    if (onReset) onReset();
  };

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
      <TextField
        label="Start Date"
        type="date"
        size="small"
        value={filters.startDate}
        onChange={handleChange('startDate')}
        InputLabelProps={{ shrink: true }}
      />

      <TextField
        label="End Date"
        type="date"
        size="small"
        value={filters.endDate}
        onChange={handleChange('endDate')}
        InputLabelProps={{ shrink: true }}
      />

      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel id="difficulty-label">Difficulty</InputLabel>
        <Select
          labelId="difficulty-label"
          label="Difficulty"
          value={filters.difficulty}
          onChange={handleChange('difficulty')}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="Easy">Easy</MenuItem>
          <MenuItem value="Medium">Medium</MenuItem>
          <MenuItem value="Hard">Hard</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="status-label">Status</InputLabel>
        <Select
          labelId="status-label"
          label="Status"
          value={filters.status}
          onChange={handleChange('status')}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="accepted">Accepted</MenuItem>
          <MenuItem value="wrong">Wrong Answer</MenuItem>
          <MenuItem value="time_limit_exceeded">Time Limit Exceeded</MenuItem>
          <MenuItem value="runtime_error">Runtime Error</MenuItem>
        </Select>
      </FormControl>

      <Button variant="contained" onClick={handleApply}>
        Apply
      </Button>
      <Button variant="outlined" onClick={handleReset}>
        Reset
      </Button>
    </Box>
  );
};

export default FiltersBar;
